import React, {useEffect, useState} from "react";
import {getUser} from "../../api.js";
import {Box, Grid} from "@mui/material";
import {getCourierAvailability} from "./api.js";
import {CourierProductsMovements} from "./CourierProductsMovements.jsx";
import {Loading} from "../../shared/Loading.jsx";

export const Availability = ({}) => {

  const [user, setUser] = useState({})
  const [availability, setAvailability] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getUser().then((user) => {
      setUser(user)
    }).catch((error) => console.error(error))
  }, []);

  useEffect(() => {
    if(user.user_id){
      setLoading(true)
      getCourierAvailability({userId: user.user_id}).then((data) => {
        setAvailability(data)
        setLoading(false)
      })
    }
  }, [user])

  return <Box component="form" sx={{ maxWidth: 600, margin: 'auto', padding: 2, bgColor: "fff" }}>
    <Grid container spacing={2}>

      <div style={{width: "100%"}}>
        <h2>Наличие</h2>

        {loading && <Loading />}

        <div className="mt-5">
          <p>Наличие курьера <b>{user.courier_full_name}</b></p>
          <p>на {availability[0]?.date}</p>
          <div className="border-dashed mt-5 border-2 p-2 rounded flex flex-col items-center">
            {availability[0]?.availability.filter(item => item.quantity).map(item => (
              <div className="flex gap-5 w-9/12 justify-between" key={item.product_title}>
                <div>{item.product_title}</div>
                <div>
                  {item.quantity} ({item.reserved_quantity}) {item.measure}
                </div>
              </div>))
            }
          </div>
        </div>

        {/*<CourierProductsMovements user={user} />*/}
      </div>

    </Grid>
  </Box>
}
